// Google API 配置
export const GOOGLE_MAPS_API_KEY = 'AIzaSyC_G3wEJ-hCsXfyLkqRjkls44v8QJZ_cGs';

// Google Places API 端点
export const GOOGLE_PLACES_AUTOCOMPLETE_URL = 'https://places.googleapis.com/v1/places:autocomplete';
export const GOOGLE_PLACES_DETAILS_URL = 'https://places.googleapis.com/v1/places';
